import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Icon } from "@/lib/icons";
import { ProgressRing } from "@/components/ProgressRing";
import { Clock, Crown } from "lucide-react";

export default function University() {
  const [paths, setPaths] = useState([]);
  useEffect(() => { api.get("/paths").then((r) => setPaths(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-8" data-testid="university-page">
      <div>
        <span className="font-mono-eco text-xs uppercase tracking-widest text-slate-500">Founder University</span>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-white tracking-tight mt-1">Guided paths from zero to founder.</h1>
        <p className="text-slate-400 mt-2">Structured learning journeys with completion tracking. Finish lessons to grow your progress.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {paths.map((p) => (
          <Link key={p.id} to={`/university/${p.id}`} data-testid={`path-${p.id}`} className="eco-card eco-card-hover p-6 flex items-center gap-5">
            <ProgressRing value={p.percent} size={64} />
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <Icon name={p.icon} size={18} className="text-[#4d8bff]" />
                <h3 className="font-display text-lg font-semibold text-white truncate">{p.title}</h3>
                {p.level === "Advanced" && <Crown size={14} className="text-amber-400 shrink-0" />}
              </div>
              <p className="text-sm text-slate-400 mt-1 line-clamp-2">{p.description}</p>
              <div className="flex items-center gap-3 mt-3 text-xs text-slate-500">
                <span className="eco-tag">{p.level}</span>
                <span className="flex items-center gap-1"><Clock size={12} /> ~{p.estimatedHours}h</span>
                <span>{p.completed_lessons}/{p.total_lessons} lessons</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
